class DownloadService {
    constructor(api, fileSaver) {
        this.api = api
        this.fileSaver = fileSaver
    }

    download(url, params = {}) {
        return this.api
            .get(url, { responseType: 'blob', ...params })
            .then(resp => {
                let [disposition, filename] = resp.headers('content-disposition').split(';')

                if (disposition === 'inline') {
                    const url = URL.createObjectURL(resp.data)

                    if (!window.open(url)) {
                        Confirm.warning(
                            "Seu navegador bloqueou a exibição de popups",
                            `
                            Para que esta mensagem não apareça novamente, por favor, permita a 
                            criação de popups no lado direito da barra de endereço de seu navegador.
                            <a target="_blank" href="https://intercom.help/eficiencia-fiscal/perguntas-frequentes/desbloqueando-pop-ups-no-chrome">
                                Clique aqui para mais informações.
                            </a>
                            `,
                            {
                                "Cancelar": angular.noop,
                                "Visualizar arquivo": () => window.open(url)
                            }
                        )
                    }
                } else {
                    filename = filename.split('=')[1].replace(new RegExp('"', 'g'), '')

                    this.fileSaver.saveAs(resp.data, filename)
                }

                return { ...resp, disposition, filename }
            })
    }

    resumeOperation(operationFun, params = {}, next = null) {
        return operationFun(next)
            .then(({token, next}) => {
                return this
                    .download(`/resume-operation/${token}`, params)
                    .then(() => {
                        if (next) {
                            return Confirm.info(
                                "Download parcial",
                                "Devido ao limite da operação solicitada, " +
                                "não foi possível incluir todos os resultados. " +
                                "Deseja realizar o download do próximo lote?",
                                {
                                    "Não": angular.noop,
                                    "Sim": () => this.resumeOperation(operationFun, params, next)
                                }
                            )
                        }
                    })
            })
        
    }
}

angular.module('eficienciaFiscalModule').service('downloadService', ['api', 'FileSaver', DownloadService])
